import React from "react";

/**
 * Custom Checkbox Component
 * @param {boolean} checked - Trạng thái tick hay không tick
 * @param {function} onChange - Callback khi click
 * @param {string} size - Kích thước: 'sm' | 'md' | 'lg' (mặc định: 'md')
 * @param {boolean} disabled - Vô hiệu hóa checkbox
 * @param {boolean} blink - Hiệu ứng nhấp nháy (cho ngày hôm nay chưa điểm danh)
 * @param {string} className - Class bổ sung
 */
const Checkbox = ({
  checked = false,
  onChange,
  size = "md",
  disabled = false,
  blink = false,
  className = "",
}) => {
  // Kích thước tương ứng
  const sizeClasses = {
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };

  const checkSizeClasses = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        className={`
          ${sizeClasses[size]}
          flex items-center justify-center
          rounded-sm
          border-2
          transition-all duration-200
          ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:shadow-lg hover:scale-110"}
          ${checked ? "bg-red-600 border-red-700" : "bg-red-600 border-red-700"}
          ${blink && !checked ? "checkbox-blink" : ""}
          ${className}
        `}
        style={{
          boxShadow: checked ? "0 0 8px rgba(234, 179, 8, 0.5)" : "none",
        }}
      >
        {checked && (
          <svg
            className={`${checkSizeClasses[size]} text-yellow-400`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth={3}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
        {/* Hiển thị dấu check mờ nhấp nháy khi blink và chưa checked */}
        {blink && !checked && (
          <svg
            className={`${checkSizeClasses[size]} text-yellow-400 opacity-0 checkbox-check-blink`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth={3}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </button>
      
      {/* CSS cho hiệu ứng nhấp nháy */}
      <style jsx>{`
        @keyframes blinkCheckbox {
          0%, 100% {
            box-shadow: 0 0 5px rgba(234, 179, 8, 0.3);
          }
          50% {
            box-shadow: 0 0 15px rgba(234, 179, 8, 0.8), 0 0 25px rgba(234, 179, 8, 0.5);
          }
        }
        
        @keyframes blinkCheck {
          0%, 100% {
            opacity: 0;
          }
          50% {
            opacity: 0.7;
          }
        }
        
        .checkbox-blink {
          animation: blinkCheckbox 1.5s ease-in-out infinite;
        }
        
        .checkbox-check-blink {
          animation: blinkCheck 1.5s ease-in-out infinite;
        }
      `}</style>
    </>
  );
};

export default Checkbox;
